import type { TriggerType } from '@post-office/shared-contracts/types';

/**
 * Determines if a message is client-triggered (requires waitForTrigger).
 * Client-triggered messages have triggerType of 'gasV3' or 'poTrigger'.
 *
 * @param triggerType - The trigger type from message context
 * @returns true if the message is client-triggered (gasV3 or poTrigger)
 */
export const isClientTriggeredMessage = (triggerType?: TriggerType): boolean => {
	if (!triggerType) {
		return false;
	}

	return triggerType === 'gasV3' || triggerType === 'poTrigger';
};
